const ID_ERROR_MESSAGE = 'An `id` must be provided to format a message.';

export { ID_ERROR_MESSAGE };
